import React from 'react'

import { confirmBase, errorBase, getOfficeNEXTURL } from 'utils/ui'
import i18n from 'i18n'
import parse from 'html-react-parser'
import { Typography, Button } from 'antd'
import classNames from 'classnames'
import { appConfig } from 'services/landing'
import expiredSubscribeImage from '@/assets/images/expired-subscribe-image.png'

const { Link } = Typography

function warning(options) {
  const props = {
    title: options.title,
    content: options.content,
    width: options.width || 450,
  }

  if (options.icon !== undefined) {
    props.icon = options.icon
  }

  return errorBase(props)
}

export function SubscribePopup(t, role) {
  const link = () => {
    if (role === 'admin') {
      return process.env.REACT_APP_TARGET === 'production'
        ? 'https://org.officenext.net/ko/subscribe/membership'
        : 'https://dev-org.officenext.net/ko/subscribe/membership'
    }
    return 'https://officenext.net'
  }
  return warning({
    title: t('login.error.notFoundWorkspaceTitle'),
    content: (
      <React.Fragment>
        <div>{parse(t('login.error.notFoundWorkspace'))}</div>
        <a href={link()} target="_blank" rel="noreferrer">
          {link()}
        </a>
      </React.Fragment>
    ),
    width: 480,
  })
}

export function ExpiredSubscribePopup(t, role, onClose) {
  // KR 계약 만료 팝업: 구독/상담 버튼(관리자용)은 owner+admin 모두 노출.
  // safebox admin은 owner가 수동 부여하며 계약 연장 유도 대상이므로 owner와 동일 취급.
  // onClose(선택): 팝업 닫힘(X/마스크/ESC) 시 호출 — SSO 로그인 차단 경로에서 officenext 로그아웃에 사용.
  const isAdmin = role === 'admin' || role === 'owner'

  const link = {
    moreInfo: 'https://officenext.net/content',
    consulting: 'https://whattime.co.kr/officeware/callbooking2?time_zone=Asia/Seoul',
    subscribe:
      process.env.REACT_APP_TARGET === 'production'
        ? 'https://org.officenext.net/ko/subscribe/membership'
        : 'https://dev-org.officenext.net/ko/subscribe/membership',
  }

  const content = isAdmin ? (
    <React.Fragment>
      <p>{t('login.desc.expiredSubscribe')}</p>
      <p>{parse(t('login.desc.expiredSubscribeDesc'))}</p>
      <Link underline onClick={() => window.open(link.moreInfo)}>
        {t('login.button.moreInfo')}
      </Link>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <p>{t('login.desc.expiredSubscribe')}</p>
      <p>{parse(t('login.desc.expiredSubscribeDesc2'))}</p>
    </React.Fragment>
  )

  const footer = isAdmin ? (
    <div className="footer-wrap">
      <Button className="cancelBtn" onClick={() => window.open(link.consulting)}>
        {t('login.button.consulting')}
      </Button>
      <Button type="primary" className="primaryBtn" onClick={() => window.open(link.subscribe)}>
        {t('login.button.subscribe')}
      </Button>
    </div>
  ) : (
    <Button type="primary" onClick={() => window.open(link.moreInfo)} className="primaryBtn">
      {t('login.button.moreInfo')}
    </Button>
  )

  return confirmBase({
    className: classNames('confirm-base-wrap-1'),
    title: <img src={expiredSubscribeImage} alt="expired-subscribe-image" />,
    closable: true,
    closeIcon: <span className="custom-close-icon" />,
    content,
    width: 480,
    height: 500,
    footer,
    // 팝업 닫힘 시 콜백(officenext 로그아웃). onClose 미전달 시 no-op(기존 호출처 하위호환).
    onCancel: onClose,
  })
}

export const notMatchingEmailConfirmBase = (t = i18n) => {
  return confirmBase({
    title: t('logOut.title.officeNext'),
    content: t('login.error.notMatchingEmail'),
    okButtonProps: {
      className: classNames('type1', 'h38'),
      style: { minWidth: '100px' },
    },
    cancelButtonProps: {
      className: classNames('h38'),
      style: { minWidth: '100px' },
    },
    width: 450,
    okText: t('logOut.button.logoutOfficeNEXT'),
    cancelText: t('common.button.close'),
    onOk: () => {
      const logoutURL = getOfficeNEXTURL('/logout')

      if (logoutURL != null && logoutURL.length > 0) {
        window.open(logoutURL)
      }
    },
  })
}

export function SsoNotEnabledPopup(t) {
  return errorBase({
    title: t('login.sso.notEnabled'),
    content: t('login.sso.notEnabledDesc'),
    okText: t('common.button.ok'),
  })
}

export function checkEmail(email, options) {
  const { t } = options

  appConfig(email || undefined)
    .catch((err) => {
      console.log(' appConfig err - ', err)
      if (err.code != null && err.code === 604) {
        ExpiredSubscribePopup(t)
      } else {
        warning({
          content: err.message,
        })
      }
    })
    .finally(() => {
      return true
    })
}
